// extracted by mini-css-extract-plugin
export default {"iconBtn":"Controls_iconBtn__pA4R-","mainBtn":"Controls_mainBtn__a8Jkq","passBtn":"Controls_passBtn__mIj2t","hideOnDesktop":"Controls_hideOnDesktop__7BxUc"};